import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { HeaderIcon, HeaderLabel, HeaderWrapper } from './styles';

export interface ProgressChecklistHeaderProps {
    allPassed: boolean;
    successText?: string;
    errorText?: string;
}

const ProgressChecklistHeader = ({
    allPassed,
    successText = 'No Missing Fields',
    errorText = 'Missing Fields',
}: ProgressChecklistHeaderProps) => {
    return (
        <HeaderWrapper>
            <HeaderIcon $passed={allPassed}>{allPassed ? <CheckCircleOutlined /> : <WarningOutlined />}</HeaderIcon>
            <HeaderLabel>{allPassed ? successText : errorText}</HeaderLabel>
        </HeaderWrapper>
    );
};

export default ProgressChecklistHeader;
